import React, { useEffect, useState } from 'react'
import HomeItem from './HomeItem'
import HomeBanner from './HomeBanner'
import HomeProject from './HomeProject';
import { API } from '../../../Services/axios';
import { URLS } from '../../../Services/urls';
import useSWR from 'swr';
import { useNavigate, useDispatch } from 'react-router-dom';

const Home = () => {

  const  [projects, setProjects] = useState([])
  const [nextPage, setNextPage] = useState(false);

  // const navigate = useNavigate();
  // const dispatch = useDispatch()

  // const { data: proj, error, isLoading } = useSWR(URLS.PROJECT.createProject)

  // const handleClick = () => {
  //   setNextPage(true);
  //   navigate('/essence');
  //   // dispatch(verifyStep(steps))
  // }

  // const convertText = (text) => {
  //   if (!text) return text;
  //   let convertedText = text.replace(/_/g, ' ').toLowerCase();
  //   convertedText = convertedText.charAt(0).toUpperCase() + convertedText.slice(1);

  //   return convertedText;
  // }

  // useEffect(() => {
  //   API.get('/project/')
  //   .then((resp) => {
  //     setProjects(resp.data.results)
  //     console.log("projects:", resp.data.results)
  //   })
  //   .catch((error) => {
  //     console.log("erreur:", error)
  //   })
  // }, [])

  return (
    <>
      <HomeBanner />

      <div className="container">
        <div className="d-flex">
          <div
            className=""
            style={{ marginLeft: 134, marginTop: 92, marginBottom: 53 }}
          >
            <p className="page-sub-title">[Projets]</p>
            <p className="page-title underline underline-start">
              Un projet d’aménagement ? Suivez le guide !
            </p>
          </div>
        </div>
        <div className="container text-center" style={{ marginBottom: 220 }}>
        <div className="row">

          {/* {isLoading && <p className='text-center'>Loading projects...</p>}
          {error && <p className='text-center'>Error Loading projects.</p>} */}

              <HomeItem/>
          
        </div>
      </div>
    {/* Steps */}
    <section className="nos-attouts mb-5">
      <div className="container">
        <div className="flex-box flex-5">
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>01</span>
                <img src="/assets/images/icons/service.svg" alt="" />
              </div>
              <div className="title">
                SERVICE <br />
                CONSEIL
              </div>
              <div className="text">Nos experts produits à votre disposition</div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>02</span>
                <img src="/assets/images/icons/decoupe.svg" alt="" />
              </div>
              <div className="title">
                DÉCOUPE <br />
                TRANSFORMATION
              </div>
              <div className="text">
                Une réponse aux demandes de sur-mesure et standard
              </div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>03</span>
                <img src="/assets/images/icons/stock.svg" alt="" />
              </div>
              <div className="title">
                STOCK ET <br />
                DISPONIBILITÉ
              </div>
              <div className="text">
                Retrouvez en ligne tous nos produits et toutes nos offres
              </div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>04</span>
                <img src="/assets/images/icons/delivr.svg" alt="" />
              </div>
              <div className="title">
                SERVICE <br />
                LIVRAISON
              </div>
              <div className="text">
                Livraison assurée en Nouvelle Aquitaine et Pays de la Loire
              </div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>05</span>
                <img src="/assets/images/icons/payment.svg" alt="" />
              </div>
              <div className="title">
                PAIEMENT <br />
                SÉCURISÉ
              </div>
              <div className="text">Avec le protocole 3D secure 2.0</div>
            </div>
          </div>
        </div>
      </div>
    </section>
      </div>

      {/* <section
        className="forest"
        style={{ backgroundImage: "url(/assets/images/forest.png)" }}
      >
        <div className="bg h-100" />
      </section> */}


    </>
  )
}

export default Home